import { useEffect, useState } from 'react';
import { Radio, X, ExternalLink } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LiveEventsBanner = () => {
  const [events, setEvents] = useState([]);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    fetch(`${API}/certificates/events/active`)
      .then((r) => (r.ok ? r.json() : []))
      .then(setEvents)
      .catch(() => setEvents([]));
  }, []);

  if (closed || events.length === 0) return null;

  return (
    <div className="fixed bottom-6 left-4 right-24 sm:right-auto sm:max-w-sm z-50 space-y-2" data-testid="live-events-banner">
      {events.map((ev) => (
        <div key={ev.event_id} className="bg-slate-900 text-white rounded-2xl shadow-2xl p-4 border border-red-500/40" data-testid={`live-event-${ev.event_id}`}>
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-2 text-red-400 text-xs font-bold tracking-wider">
              <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" />
              </span>
              <Radio className="w-3.5 h-3.5" /> EN VIVO
            </div>
            <button onClick={() => setClosed(true)} className="text-slate-400 hover:text-white" aria-label="Cerrar" data-testid="live-events-close-btn">
              <X className="w-4 h-4" />
            </button>
          </div>
          <p className="font-semibold mt-1" data-testid="live-event-title">{ev.title}</p>
          {ev.description && <p className="text-slate-300 text-sm mt-1">{ev.description}</p>}
          {ev.url && (
            <a href={ev.url} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-1.5 bg-red-500 hover:bg-red-600 text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors" data-testid="live-event-join-link">
              Unirme ahora <ExternalLink className="w-3.5 h-3.5" />
            </a>
          )}
        </div>
      ))}
    </div>
  );
};
